module.exports = __webpack_public_path__ + "img/立即抽奖按钮.d9f5ef33.png";